import React from 'react';
import { useStravaTranslations } from '@strava/container-context';
import clsx from '@strava/ui/clsx';
import {
  getTitleAndSubtitle,
  RegMessageVariants
} from '../../helpers/getTitleAndSubtitle';
import styles from './MobileRegistrationMessage.module.scss';
interface MobileRegistrationMessageProps {
  variant: RegMessageVariants;
  name?: string;
  className?: string;
}

export const MobileRegistrationMessage = ({
  variant,
  name,
  className
}: MobileRegistrationMessageProps) => {
  const { t } = useStravaTranslations();
  const { title, subtitle } = getTitleAndSubtitle(t, variant, name);

  return (
    <div className={clsx(styles.mobileRegistrationMessage, className)}>
      <h1 data-cy="reg-message-title">{title}</h1>
      {subtitle && <p data-cy="reg-message-subtitle">{subtitle}</p>}
    </div>
  );
};

export default MobileRegistrationMessage;
